"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var blue = {
  50: '#d5eafa',
  100: '#9ed0f6',
  200: '#6ab5ee',
  300: '#3e9ce2',
  400: '#1d85d1',
  500: '#0670ba',
  600: '#005d9b',
  700: '#004775',
  800: '#002d48',
  900: '#00101a',
  A100: '#f0f8ff',
  A200: '#4089c3',
  A400: '#065cb9',
  A700: '#002c72'
};
exports["default"] = blue;